//
//
//
//
//
//
//
//
//
//
//
//
//

import { timeFormat } from '../util'
export default {
  props: {
    item: Object
  },
  filters: {
    timeFormat: function (value) {
      if (!value) return ''
      return timeFormat(value, 'Y-m-d')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/article.vue